import { Dialog, DialogType, List, PrimaryButton, Stack, Text } from "@fluentui/react";

import "./History.css";

import { Voting } from "../../Models/Voting";
import { fetchVotingDetails, fetchHistory } from "../../Services/VoteService";
import { VotingDetails } from "../VotingDetailsComponent/VotingDetails";
import moment from "moment";
import { useEffect, useState } from "react";
import { Loading } from "../LoadingComponent/Loading";

type HistoryProps = {
  toggleDialog: () => void;
  history: Voting[];
  setHistory: React.Dispatch<React.SetStateAction<Voting[]>>;
  setVotingDetails: React.Dispatch<any>;
  votingDetails: any;
};

export function History({
  toggleDialog,
  history,
  setHistory,
  setVotingDetails,
  votingDetails,
}: HistoryProps) {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (history.length > 0) {
      return;
    } else {
      const fetchData = async () => {
        setIsLoading(true);
        setHistory(await fetchHistory());
        setIsLoading(false);
      };
      fetchData();
    }
  });

  async function reFetchHistory() {
    setIsLoading(true);
    setHistory(await fetchHistory());
    setIsLoading(false);
  }

  return (
    <>
      <Dialog
        hidden={false}
        onDismiss={toggleDialog}
        dialogContentProps={{
          type: DialogType.largeHeader,
        }}
        modalProps={{
          isBlocking: false,
        }}
        minWidth={1000}
        maxWidth={10000}
      >
        <Stack className="HistoryHeader">
          <div>
            <button onClick={() => reFetchHistory()}>
              <img
                src="https://www.svgrepo.com/show/335247/refresh.svg"
                alt="Refresh Button"
                height={"25px"}
              />
            </button>
          </div>
          <Text variant="xxLarge">History</Text>
          <PrimaryButton onClick={toggleDialog} text="Schliessen" />
        </Stack>
        <Stack
          verticalAlign="space-between"
          horizontal
          tokens={{ childrenGap: 50 }}
          className="dialogBody"
        >
          {isLoading ? (
            <>
              <div className="Loading">
                <Loading />
              </div>
            </>
          ) : (
            <>
              <div className="votingHistoryContainer">
                <List
                  className="votingHistoryList"
                  items={history}
                  onRenderCell={(item: any, index) =>
                    item ? (
                      <div className="VotingBox" key={item.id}>
                        <Text className="HistoryTitle">{item.title}</Text>
                        <Text className="HistoryEntryDate">
                          {item.date ? moment(item.date).format("DD.MM.YYYY") : ""}
                        </Text>
                        <Text className="HistoryResult">Ergebnis: {item.result.toFixed(1)}</Text>
                        <PrimaryButton
                          text="Details"
                          onClick={async () => setVotingDetails(await fetchVotingDetails(item.id))}
                        />
                      </div>
                    ) : (
                      <Text key={`empty-${index}`}>Item konnte nicht geladen werden</Text>
                    )
                  }
                />
              </div>
            </>
          )}
          {/* Divider for clarity*/}
          {votingDetails !== undefined && (
            <VotingDetails votingDetails={votingDetails} setVotingDetails={setVotingDetails} />
          )}
        </Stack>
      </Dialog>
    </>
  );
}
